import { audioUrl } from 'config/sources';

export type ToeicDictationSource = {
  title: string;
  transcript: string;
  audioSrc: string;
};

function decodeEntities(text: string): string {
  const named: { [key: string]: string } = {
    amp: '&',
    apos: "'",
    gt: '>',
    hellip: '...',
    ldquo: '"',
    lsquo: "'",
    lt: '<',
    mdash: '-',
    nbsp: ' ',
    ndash: '-',
    quot: '"',
    rdquo: '"',
    rsquo: "'",
  };

  return text
    .replace(/&([a-z]+);/gi, (match, name) => named[name.toLowerCase()] || match)
    .replace(/&#(\d+);/g, (_match, code) => String.fromCharCode(Number(code)))
    .replace(/&#x([0-9a-f]+);/gi, (_match, code) => String.fromCharCode(parseInt(code, 16)));
}

export function htmlToDictationText(html: string): string {
  return decodeEntities(
    String(html || '')
      .replace(/<\s*br\s*\/?>/gi, '\n')
      .replace(/<\/(div|p|li|section|article)>/gi, '\n')
      .replace(/<[^>]*>/g, '')
  )
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n[ \t]+/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function getToeicAudioIndex(part: number, itemOneBased: number): number {
  if (part < 1 || part > 4) throw new Error('Part TOEIC phải từ 1 đến 4.');
  if (!Number.isInteger(itemOneBased) || itemOneBased < 1) {
    throw new Error('Số bài TOEIC không hợp lệ.');
  }
  return part === 2 ? itemOneBased + 6 : itemOneBased;
}

export function extractToeicTranscript(part: number, item: any): string {
  if (!item) return '';
  if (part === 1) {
    return [item.a, item.b, item.c, item.d].filter(Boolean).join('\n').trim();
  }
  if (part === 2) {
    return [item.question, item.a, item.b, item.c].filter(Boolean).join('\n').trim();
  }
  if (part === 3 || part === 4) {
    let text = htmlToDictationText(item.data && item.data.html);
    if (part === 3) {
      text = text.replace(/(^|\n)\s*[ABC]\s*:\s*/g, '$1').trim();
    }
    return text;
  }
  return '';
}

export function createToeicDictationSource(
  year: string,
  test: number,
  part: number,
  itemOneBased: number,
  items: any[]
): ToeicDictationSource {
  if (!Array.isArray(items) || itemOneBased > items.length) {
    throw new Error('Bài đã chọn không tồn tại trong dữ liệu TOEIC.');
  }
  const item = items[itemOneBased - 1];
  const transcript = extractToeicTranscript(part, item);
  if (!transcript) throw new Error('Bài TOEIC này chưa có transcript tiếng Anh.');

  const cue = part >= 3 && item.data && item.data.title ? ` — ${item.data.title}` : '';
  return {
    title: `TOEIC ${year} · Test ${test} · Part ${part} · Bài ${itemOneBased}${cue}`,
    transcript,
    audioSrc: audioUrl(year, test, part, getToeicAudioIndex(part, itemOneBased)),
  };
}
